<div *ngIf="targetType && targetId">
  <form id="noteForm"
        [formGroup]="form"
        novalidate
        #f>
    <div class="flex"
         [ngSwitch]="noteType">
      <mat-form-field class="col__"
                      *ngSwitchCase="'date'">

        <mat-label>Date</mat-label>
        <input matInput
               [matDatepicker]="datePicker"
               placeholder="MM/DD/YYYY"
               autocomplete="off"
               formControlName="text"
               appAutofocus
               [appAutofocusDisabled]="!shouldAutofocusInput"
               name="date">
        <mat-datepicker-toggle matSuffix
                               [for]="datePicker">
          <mat-icon fontSet="far"
                    fontIcon="fa-calendar"
                    matDatepickerToggleIcon></mat-icon>
        </mat-datepicker-toggle>
        <mat-datepicker #datePicker></mat-datepicker>
        <app-input-error [formControlItem]="form.get('note')"></app-input-error>
      </mat-form-field>

      <mat-form-field class="col__"
                      *ngSwitchCase="'number'">
        <mat-label>Value</mat-label>
        <input type="text"
               appAutofocus
               [appAutofocusDisabled]="!shouldAutofocusInput"
               matInput
               decimalMask
               formControlName="text"
               data-test-id="numberInput" />
      </mat-form-field>

      <mat-form-field class="col__"
                      *ngSwitchDefault>
        <textarea matInput
                  appAutofocus
                  [appAutofocusDisabled]="!shouldAutofocusInput"
                  cdkTextareaAutosize
                  cdkAutosizeMinRows="3"
                  cdkAutosizeMaxRows="8"
                  formControlName="text"
                  data-test-id="noteInput"></textarea>
      </mat-form-field>
    </div>

    <div class="flex mt-0050 flexJustify--between flexAlign--center">
      <div>
        <ng-content></ng-content>

      </div>
      <button type="button"
              class="btn"
              (click)="onSave(f)"
              [disabled]="!form.valid"
              data-test-id="saveNoteBtn">Save</button>
    </div>

  </form>
</div>
